import React, { useState, useMemo } from 'react'
import './order-deilver.scss'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage, showLayer } from '@/utils/layer'
import { Radio } from 'antd'
import { useDynamicList, useRequest } from 'ahooks'
import useBemClass from '@/utils/hooks/useBEMClass'
import classnames from 'classnames'
import { Column, Row } from '@/components/layout/layout'
import Iconfont from '@/components/iconfont/iconfont'
import DeliverCompany from './deliver-company/deliver-company'
import { $post } from '@/api'
import { errorCallBack } from '@/utils'
import $msg from '@/utils/message'
import Button from '@/components/button/button'

interface IExpressInfo {
    express_company: string
    tracking_number: string
    name: string
}

interface MallOrderDeilverProps {
    orderId: number
    orderType: number
    refresh: () => void
}

const MallOrderDeilver: React.FC<MallOrderDeilverProps> = props => {
    const cls = useBemClass('mall-order-deliver')

    const [deliverType, setDeliverType] = useState<number>(1)
    const [activeInput, setActiveInput] = useState<number>(0)

    const { list: expressList, getKey, replace, push, remove } = useDynamicList<IExpressInfo>([
        { express_company: '', tracking_number: '', name: '' },
    ])

    const ordeDeliverReq = useRequest(
        () =>
            $post({
                url: '/mall/orderdeliver',
                params: {
                    delivery_type: deliverType,
                    express_info: expressList.map(e => ({
                        express_company: e.express_company,
                        tracking_number: e.tracking_number,
                    })),
                    order_id: props.orderId,
                    order_type: props.orderType,
                },
            }),
        {
            manual: true,
            onError: errorCallBack,
            onSuccess: () => {
                $msg('success', '发货成功')
                layerManage.pop()
                props.refresh()
            },
        },
    )

    const benDisabled = useMemo(() => {
        if (deliverType !== 2) {
            return false
        } else {
            return !expressList.every(e => e.express_company && e.tracking_number)
        }
    }, [deliverType, expressList])

    return (
        <BaseDialog
            isShow
            onClose={() => {
                layerManage.pop()
            }}
            title="发货设置"
        >
            <Column className={cls('c')}>
                <Radio.Group
                    value={deliverType}
                    onChange={event => {
                        setDeliverType(event.target.value)
                    }}
                >
                    <Radio value={1}>商家直送</Radio>
                    <Radio value={2}>快递物流</Radio>
                    <Radio value={3}>外卖配送</Radio>
                </Radio.Group>
                {deliverType === 2 && (
                    <>
                        {expressList.map((exprsss, index) => (
                            <Row data-margin-top-10 data-align-items-center data-wdith-100p key={getKey(index)}>
                                <div
                                    className={classnames(cls('container'), {
                                        [cls('container', 'active')]: activeInput === index,
                                    })}
                                >
                                    <div
                                        className={classnames(cls('container-left'), {
                                            [cls('container-left', 'active')]: activeInput === index,
                                        })}
                                        onClick={() => {
                                            showLayer(
                                                <DeliverCompany
                                                    selectCompanyId={exprsss.express_company}
                                                    onSelect={company => {
                                                        replace(index, {
                                                            ...exprsss,
                                                            express_company: company.id,
                                                            name: company.name,
                                                        })
                                                    }}
                                                />,
                                            )
                                        }}
                                    >
                                        {exprsss.name || '快递物流'}
                                        <i className="iconfont icon6xiala2-202" />
                                    </div>
                                    <input
                                        autoFocus={index === expressList.length - 1}
                                        placeholder="请填写快递单号"
                                        value={exprsss.tracking_number}
                                        onFocus={() => setActiveInput(index)}
                                        className={cls('ipt')}
                                        onChange={e => {
                                            replace(index, {
                                                ...exprsss,
                                                tracking_number: e.target.value,
                                            })
                                        }}
                                    />
                                </div>
                                {expressList.length > 1 && (
                                    <div
                                        data-margin-left-8
                                        data-cursor-pointer
                                        onClick={() => {
                                            remove(index)
                                        }}
                                    >
                                        <Iconfont name="icon6yichu-20" size={20} />
                                    </div>
                                )}
                            </Row>
                        ))}
                        {expressList.length < 3 && (
                            <Row
                                data-width-100p
                                data-margin-top-10
                                data-justify-content-center
                                className="action"
                                onClick={() => {
                                    push({
                                        express_company: '',
                                        tracking_number: '',
                                        name: '',
                                    })
                                }}
                            >
                                +添加快递单号
                            </Row>
                        )}
                    </>
                )}
            </Column>
            <Row className={cls('bottom')}>
                <Button
                    style={{
                        color: '#999',
                        fontWeight: 600,
                    }}
                    types="text"
                    onClick={() => layerManage.pop()}
                >
                    取消
                </Button>
                <Button
                    disabled={benDisabled}
                    types="default"
                    loading={ordeDeliverReq.loading}
                    onClick={ordeDeliverReq.run}
                >
                    确定
                </Button>
            </Row>
        </BaseDialog>
    )
}

export default MallOrderDeilver
